import React from "react";
import "./Gallery.css";
import Tyre1 from "../assets/DEA.webp";
import Tyre2 from "../assets/ds.webp";
import Tyre3 from "../assets/contactbanner.webp";
import Tyre4 from "../assets/kcs.webp";
import Tyre5 from "../assets/pc.webp";
import Tyre6 from "../assets/Ecu.webp";

function Gallery() {
  return (
<section class="gallery-section">
   <div class="gallery-heading">
    {/* <span class="gallery-subtitle">Our Work</span> */}
    <h2 class="gallery-title">Car Forensics <span>Gallery</span></h2>
    <div class="heading-line"></div>
  </div>
  <div class="gallery-wrapper">
    <div class="gallery-track">
      <div class="gallery-item"><img src={Tyre1} alt="Gallery 1" loading="lazy"/></div>
      <div class="gallery-item"><img src={Tyre2} alt="Gallery 2" loading="lazy"/></div>
      <div class="gallery-item"><img src={Tyre3} alt="Gallery 3" loading="lazy"/></div>
      <div class="gallery-item"><img src={Tyre4} alt="Gallery 4" loading="lazy"/></div>
      <div class="gallery-item"><img src={Tyre5} alt="Gallery 5" loading="lazy"/></div>
      <div class="gallery-item"><img src={Tyre6} alt="Gallery 6" loading="lazy"/></div>

      <div class="gallery-item"><img src={Tyre1} alt="Gallery 1" loading="lazy"/></div>
      <div class="gallery-item"><img src={Tyre2} alt="Gallery 2" loading="lazy"/></div>
      <div class="gallery-item"><img src={Tyre3} alt="Gallery 3" loading="lazy"/></div>
      <div class="gallery-item"><img src={Tyre4} alt="Gallery 4" loading="lazy"/></div>
      <div class="gallery-item"><img src={Tyre5} alt="Gallery 5" loading="lazy"/></div>
      <div class="gallery-item"><img src={Tyre6} alt="Gallery 6" loading="lazy"/></div>
    </div>
  </div>
</section>

  );
}

export default Gallery;